import { FlexibleImageSrc } from 'types'

export const parseImageSrc = (
  imageSrc: FlexibleImageSrc,
): { src: string; srcSet: string } => {
  if (typeof imageSrc === 'string') {
    return { src: imageSrc, srcSet: '' }
  } else {
    const {
      hero,
      heroWidth,
      heroLarge,
      heroLargeWidth,
      large,
      largeWidth,
      medium,
      mediumWidth,
      small,
      smallWidth,
    } = imageSrc
    const sources = [
      `${small} ${smallWidth}w`,
      `${medium} ${mediumWidth}w`,
      `${large} ${largeWidth}w`,
    ]

    if (hero && heroWidth) {
      sources.push(`${hero} ${heroWidth}w`)
    }

    if (heroLarge && heroLargeWidth) {
      sources.push(`${heroLarge} ${heroLargeWidth}w`)
    }

    const srcSet = sources.join(', ')
    const src = large
    return { src, srcSet }
  }
}
